/** @jsx jsx */
import Layout from '@lekoarts/gatsby-theme-emilia/src/components/layout'
import Header from '@lekoarts/gatsby-theme-emilia/src/components/header'
import {Flex, Box, Container, Heading, jsx} from 'theme-ui'
import services from './price-data.json'

const PricesPage = () => {
  return (
    <Layout>
      <Header small />
      <Box as='main' variant='layout.main'>
        <Container
          sx={{
            maxWidth: '80ch',
            textAlign: [null, null, 'center'],
          }}
        >
          <Heading as='h2' variant='styles.h2'>
            Our Prices:
          </Heading>
          {services.map(service => (
            <Flex sx={{justifyContent: 'space-between', mb: '1rem'}}>
              <Box>{service.text}</Box>
              <Box sx={{textAlign: 'right'}}>{service.price}</Box>
            </Flex>
          ))}
        </Container>
      </Box>
    </Layout>
  )
}

export default PricesPage
